import React from 'react';
import Banner from './Banner';
import Certifications from './Certifications';
import Footer from './Footer';
import Gallery from './Gallery';
import MainContainer from './MainContainer';
import Products from './Products';
import RelevantInfo from './RelevantInfo';
import Slogan from './Slogan';
import StartQuoting from './StartQuoting';

const LandingPage = () => {
  return (
    <MainContainer>
      <Banner />
      <StartQuoting />
      <Certifications />
      <Products />
      <RelevantInfo />
      <Slogan />
      <Gallery />
      <Footer />
    </MainContainer>
  )
}

export default LandingPage;
